import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./customerProfile.scss";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Loading from "../loading/Loading";

const CustomerPrice = ({ buyerId }) => {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const columns = [
    { field: "sku", headerName: "LR Code", width: 150 },
    {
      field: "addedPhotos",
      headerName: "Image",
      width: 100,
      renderCell: (params) =>
        params.row.addedPhotos && params.row.addedPhotos.length > 0 ? (
          params.row.addedPhotos.map((item, index) => (
            <img
              key={index}
              src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item}`}
              alt={`Product ${index + 1}`}
              style={{
                marginTop: "10px",
                width: "30px",
                height: "30px",
                objectFit: "cover",
                marginRight: "5px",
                borderRadius: "50px",
                background: "lightgray",
                alignItems: "center",
              }}
            />
          ))
        ) : (
          <small>No Image</small>
        ),
    },
    { field: "title", headerName: "Title", width: 300 },
    // { field: "brand", headerName: "Brand", width: 200 },
    //{ field: "category", headerName: "Category", width: 200 },
    // 👇 Standard price column
    { field: "price", headerName: "Price (Kg) ", width: 120 },

    // 👇 New customer-specific price column
    {
      field: "customerPrice",
      headerName: "Customer Price",
      width: 100,
      renderCell: (params) =>
        params.row.customerPrice ? (
          <strong style={{ color: "green" }}>{params.row.customerPrice}</strong>
        ) : (
          <span style={{ color: "gray" }}>—</span>
        ),
    },
    { field: "pkg", headerName: "UOM ", width: 100 },
  ];

  useEffect(() => {
    if (!buyerId) return;

    const getAllProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-all-products");
        const mappedProducts = response.data.map((item) => {
         const newCustomerPrice = item.customerPrice || [];

         // 1. Log the buyerId you are receiving
        //  console.log("Input Buyer ID:", buyerId);
         // Format the buyerId once for comparison
         const formattedBuyerId = buyerId.trim().toLowerCase();
        //  console.log("Formatted Buyer ID:", formattedBuyerId);
         const specialPrice = newCustomerPrice.find((cp) => {
           // 2. Log the customerId being checked from the product data
           const productCustomerId = cp.customerId;
           const formattedProductCustomerId = productCustomerId
             .trim()
             .toLowerCase();
           // Log the comparison values right before the check
          //  console.log(
          //    `Comparing: "${formattedBuyerId}" vs "${formattedProductCustomerId}"`
          //  );
           // The comparison logic (using the trimmed/lowercased values)
           return formattedProductCustomerId === formattedBuyerId;
         });

         //console.log("specialPrice found:", specialPrice);

          return {
            id: item._id,
            sku: item.lrCode || "",
            addedPhotos: item.proPhotos || [],
            title: item.name || "",
            price: item.price || 0,
            customerPrice: specialPrice?.price || "",
            pkg: specialPrice?.unitOfMeasureCode || "", // <-- now works
          };
        });

        setProducts(mappedProducts);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    getAllProduct();
  }, [buyerId]);

  const handleCellClick = (id) => {
    console.log(id);
  };

  return (
    <>
      <div className="main_wrp">
        <div className="main_page_wrp">
          <div className="main_body_wrp">
            {loading ? (
              <>
                {" "}
                <Loading />{" "}
              </>
            ) : (
              <DataGrid
                key={products.id}
                // rows={productData.filter((product) => product.status === "pending")}
                rows={products}
                columns={columns}
                pageSize={5}
                over
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: {
                      //pageSize:
                    },
                  },
                }}
                getRowId={(row) => row.id}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                onCellClick={(params) => {
                  navigate(`/update-customer-price?proId=${params.row.id}&customerId=${buyerId}`);
                }}
              />
            )}
          </div>

          {/* {products.map((item) => (
            <div key={item.id}>
              <img
                style={{
                  marginTop: "10px",
                  width: "30px",
                  height: "30px",
                  objectFit: "cover",
                  marginRight: "5px",
                  borderRadius: "50px",
                  background: "lightgray",
                  alignItems: "center",
                }}
                src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${item.addedPhotos}`}
                alt=""
              />
              <p>{item.title}</p>
              <p>{item.customerPrice}</p>
              <p>{item.sku}</p>
              <p>{item.price}</p>
            </div>
          ))} */}
        </div>
      </div>
    </>
  );
};

export default CustomerPrice;
